import { Box, Container, Grid2, Typography, Button, Link } from '@mui/material'

export const EmailUnverified = () => {
  const handleClick = () => {
    window.location.href = 'https://www.terashite.jp/'
  }
  return (
    <Box>
      <Container maxWidth="xl">
        <Grid2 container justifyContent={'center'}>
          <Grid2 size={{ lg: 8, sm: 8 }} spacing={4}>
            <Box display={'flex'} justifyContent={'center'}>
              <Box
                component="img"
                sx={{
                  height: 128
                }}
                alt="Logo"
                src="/assets/TC-ID_square.png"
                position={'relative'}
              />
            </Box>
          </Grid2>
          <Grid2 size={{ lg: 8, sm: 8 }} mt={2}>
            <Typography variant="h4" align="center">
              TCID
            </Typography>
            <Typography variant="body1" mt={5} align="center">
              入力いただいたメールアドレスに「メールアドレスの確認」メールを送信しました。
            </Typography>
            <Typography variant="body1" mt={7} align="center" color="error">
              ※登録はまだ完了していません。
              <br />
              「メールアドレスの確認」メールを開き、リンクをクリックしてメール認証を完了してください。
            </Typography>
            <Typography variant="body1" mt={10} align="center">
              メールが届かない場合は
              <Link href="https://id.chuden.co.jp/" target="_blank">
                こちら
              </Link>
            </Typography>
            <Box display={'flex'} justifyContent={'space-around'} mt={10}>
              <Button variant="contained" color="primary" onClick={handleClick}>
                テラシテトップに戻る
              </Button>
            </Box>
          </Grid2>
        </Grid2>
      </Container>
    </Box>
  )
}
